var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/shopping-cart"}},[_c('i',{staticClass:"fas fa-shopping-cart"}),_vm._v(" "),(_vm.$store.state.cartCount > 0)?_c('span',[_vm._v("("+_vm._s(_vm.$store.state.cartCount)+")")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }